import { MENU_CURATION_TASK_STATUS } from '../../menu-curation-tasks/constants'

const computeDishRowDisabled = ({ dish, taskStatus, isTaskDisabled }) => {
  if (isTaskDisabled) {
    return true
  }

  if (dish.isLocked) {
    return true
  }

  if (
    taskStatus === MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value &&
    dish.isTierOneDone
  ) {
    return true
  }

  if (
    taskStatus === MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value &&
    dish.isCurationDone
  ) {
    return true
  }

  if (
    taskStatus === MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value &&
    (dish.isQaDone || !dish.isCurationDone)
  ) {
    return true
  }

  if (
    taskStatus === MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value &&
    (dish.isQcDone || !dish.isQaDone)
  ) {
    return true
  }

  return false
}

export default computeDishRowDisabled
